import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Rules, RulesForm, RulesNewForm} from '../models/rules';

export const rulesUpdateActionTypes = {
  UPDATE: type('[Rules] Update'),
  UPDATE_NEW_RULES: type('[Rules] Update new rules'),
  UPDATE_SUCCESS: type('[Rules] Update Success'),
  UPDATE_FAIL: type('[Rules] Update Fail'),
};

export class UpdateRulesAction implements Action {
  readonly type = rulesUpdateActionTypes.UPDATE;
  constructor(public payload?:  {form: RulesForm , data: Rules}) {}
}
export class UpdateNewRulesAction implements Action {
  readonly type = rulesUpdateActionTypes.UPDATE_NEW_RULES;
  constructor(public payload?:  RulesNewForm) {}
}

export class UpdateRulesSuccessAction implements Action {
  readonly type = rulesUpdateActionTypes.UPDATE_SUCCESS;
  constructor(public payload?: Rules) {}
}

export class UpdateRulesFailAction implements Action {
  readonly type = rulesUpdateActionTypes.UPDATE_FAIL;
  constructor(public payload?: string) {}
}
